import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import 'vant/es/toast/style';
import 'vant/es/overlay/style';
import 'vant/es/loading/style';
import logo from '../../assets/logo.png';
import downtips from '../../assets/downtips.png';
import openapptitle from '../../assets/openapptitle.png';
import openappicon from '../../assets/openappicon.png';
export default {
  name: 'OpenApp',
  data: function data() {
    return {
      logo: logo,
      openapptitle: openapptitle,
      openappicon: openappicon,
      androidUrl: 'https://app.facepopo.com/qipaoMobile/qipao.apk',
      downtips: downtips,
      showTips: false,
      opening: false
    };
  },
  computed: {
    bgStyle: function bgStyle() {
      var url = require('../../assets/dowloadBg.png');
      return {
        backgroundImage: "url('".concat(url, "')"),
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      };
    }
  },
  methods: {
    isWeChat: function isWeChat() {
      return /micromessenger/i.test(navigator.userAgent || '');
    },
    /**
     * 打开 App 点击处理（支持 Android 和 iOS）
     * 微信环境：直接跳转到 download 页
     * 普通浏览器环境：检测是否已安装 app，已安装则打开，未安装则跳转到 download 页
     */
    onOpenAppClick: function onOpenAppClick(e) {
      e.preventDefault();

      // 微信环境直接跳转到 download 页
      if (this.isWeChat()) {
        this.$router && this.$router.push({
          name: 'download'
        });
        return;
      }

      // 普通浏览器环境，尝试打开 app
      this.opening = true;
      this.tryOpenApp();
    },
    /**
     * 尝试打开 App
     * Android: 使用 Intent URL
     * iOS: 使用 window.location.href 直接打开 scheme（更可靠）
     */
    tryOpenApp: function tryOpenApp() {
      var _this = this;
      var pkg = 'ai.yingsai.packageqipao';
      var isAndroid = /android/i.test(navigator.userAgent || '');
      var fallback = function fallback() {
        _this.opening = false;
        _this.$router && _this.$router.push({
          name: 'download'
        });
      };
      var hidden = false;
      var onVis = function onVis() {
        if (document.hidden || document.visibilityState === 'hidden') {
          hidden = true;
        }
      };
      if (isAndroid) {
        // 在尝试打开前先监听页面可见性变化
        document.addEventListener('visibilitychange', onVis);
        // Android 使用 Intent URL，跳转到 /home 路径
        var fallbackUrl = "".concat(location.origin, "/#/download");
        var intent = "intent://open/home#Intent;scheme=qipao;package=".concat(pkg, ";S.browser_fallback_url=").concat(encodeURIComponent(fallbackUrl), ";end");
        window.location.href = intent;

        // Android 检测逻辑：等待 1.2 秒，如果页面未隐藏则跳转 download 页
        setTimeout(function () {
          document.removeEventListener('visibilitychange', onVis);
          if (!hidden) {
            fallback();
          }
        }, 1200);
      } else {
        fallback();
      }
    }
  }
};